import { Chains } from '@prisma/client';
import { Connection } from '@solana/web3.js';
import { networkAddresses } from '../programs';
import { Program } from '@coral-xyz/anchor';
import { IDL, Predictions } from '../IDL/prediction-market';

export class FrontendProviders {
  constructor(private readonly connection: Connection) {}

  getPredictionMarketProgram(chain: Chains) {
    const programId =
      networkAddresses[chain]?.programs.predictionMarket.programId;
    if (!programId)
      throw new Error(
        'Program ID not found, please check your network environment',
      );

    return new Program<Predictions>(IDL, programId, {
      connection: this.connection,
    });
  }

  getNetworkAddresses(chain: Chains) {
    return networkAddresses[chain];
  }
}
